import { AppState } from '../index';
import { createSelector } from '@ngrx/store';
import * as fromRequestCounter from './requestCounter.reducer';

const FALSE_BREAKPOINT = 0;

export const selectRequestCounter = ({ requestCounter }: AppState): fromRequestCounter.State => requestCounter;

export const selectRequestCounterAny = createSelector(selectRequestCounter, ({ requestCounter }) => requestCounter > FALSE_BREAKPOINT);
